const Maintenance = () => {
  return (
    <div className="min-h-screen bg-offblack flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="mb-12">
          <span className="font-display font-black text-4xl text-offwhite tracking-[0.04em]">
            ARMÉ.
          </span>
        </div>

        {/* Divider */}
        <div className="w-12 h-0.5 bg-sand mx-auto mb-10" />

        {/* Content */}
        <div className="space-y-4 mb-12">
          <h1 className="font-display text-display-sm text-offwhite">
            We'll Be Right Back
          </h1>
          <p className="text-warmgray-400 text-sm leading-relaxed max-w-sm mx-auto">
            We're making some improvements to give you a better experience.
            Check back shortly.
          </p>
        </div>

        {/* Info Cards */}
        <div className="space-y-3 mb-10">
          <div className="border border-warmgray-700 p-5">
            <p className="text-xs tracking-[0.15em] uppercase text-sand mb-1">
              Need Help?
            </p>
            <a
              href="mailto:contact@arme-store.com"
              className="text-sm text-warmgray-300 hover:text-offwhite transition-colors"
            >
              contact@arme-store.com
            </a>
          </div>
        </div>

        {/* Refresh */}
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center justify-center px-8 py-3 border border-warmgray-600 text-xs tracking-[0.12em] uppercase text-warmgray-300 hover:text-offwhite hover:border-warmgray-400 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default Maintenance;